import { useEffect } from 'react'
import { initMetaPixel } from '../utils/pixel'

export function useMetaPixel(): void {
  useEffect(() => {
    initMetaPixel()
  }, [])
}
